var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentdue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35234",
    "data-name": "Group 35234",
    transform: "translate(-757.7 -295)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9815",
    "data-name": "Rectangle 9815",
    width: 40,
    height: 40,
    transform: "translate(757.7 295)",
    fill: "red",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35289",
    "data-name": "Group 35289",
    transform: "translate(760.7 299.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72290",
    "data-name": "Path 72290",
    d: "M55.7,4.4c0,1.878-4.186,3.4-9.35,3.4S37,6.278,37,4.4m18.7,0c0-1.878-4.186-3.4-9.35-3.4S37,2.522,37,4.4m18.7,0V6.95M37,4.4V24.8c0,1.878,4.186,3.4,9.35,3.4m0-13.6q-.43,0-.85-.014C40.734,14.43,37,12.974,37,11.2m9.35,10.2C41.186,21.4,37,19.878,37,18m34-2.55c0,1.878-4.186,3.4-9.35,3.4s-9.35-1.522-9.35-3.4m18.7,0c0-1.878-4.186-3.4-9.35-3.4s-9.35,1.522-9.35,3.4m18.7,0V28.2c0,1.878-4.186,3.4-9.35,3.4s-9.35-1.522-9.35-3.4V15.45M71,21.825c0,1.878-4.186,3.4-9.35,3.4s-9.35-1.522-9.35-3.4",
    transform: "translate(-37 -1)",
    fill: "none",
    stroke: "#ef6863",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentdue);
export default __webpack_public_path__ + "static/media/paymentdue.59ef58df9e601134c6837e6e2a766b87.svg";
export { ForwardRef as ReactComponent };